export default __webpack_public_path__ + "static/media/checkbox-blank-outline.8605dda2.svg";